import { useEffect, useState } from 'react'
import api from '../services/api'

/** Imagem ou vídeo de anexo carregado com autenticação (Bearer token). */
export function AttachmentMedia({
  src,
  alt,
  type = 'image',
  className,
}: {
  src: string
  alt?: string
  type?: 'image' | 'video'
  className?: string
}) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    let revoked = false
    let createdUrl: string | null = null
    api
      .get(src, { responseType: 'blob' })
      .then((res) => {
        createdUrl = URL.createObjectURL(res.data)
        if (!revoked) setBlobUrl(createdUrl)
        else URL.revokeObjectURL(createdUrl)
      })
      .catch(() => { if (!revoked) setError(true) })
    return () => {
      revoked = true
      if (createdUrl) URL.revokeObjectURL(createdUrl)
    }
  }, [src])

  if (error || !blobUrl) {
    return (
      <div className={className} style={{ background: 'var(--secondary-100)' }}>
        <span className="text-xs text-secondary-500">Erro ao carregar</span>
      </div>
    )
  }

  if (type === 'video') {
    return (
      <video
        src={blobUrl}
        preload="metadata"
        muted
        playsInline
        className={className}
      />
    )
  }

  return <img src={blobUrl} alt={alt || ''} loading="lazy" className={className} />
}
